import React from 'react';
import { Button } from 'primereact/button';

export default function Header({ isFromCase, isFromLead, showMarkAsRead, onMarkAsReadClick, hasSelectedThreads }) {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        {!isFromCase && !isFromLead && (
          <>
            <div className="d-flex">
              <h1 className="title gray-800 mb-0">Text Messages</h1>
            </div>
          </>
        )}
      </div>
    </>
  );
}
